import dashboardRoute from "pages/Dashboard/dashboardRoute";
import accountsRoute from "pages/Accounts/accountsRoute";
import accountRoute from "pages/Account/accountRoute";
import actionLogRoute from "pages/ActionLog/actionLogRoute";
import iuVersionRoute from "pages/IncrementalUpgradeVersion/iuVersionRoute";
import iuVersionsRoute from "pages/IncrementalUpgradeVersions/iuVersionsRoute";
import licensesRoute from "pages/Licenses/licensesRoute";
import licenseTemplateRoute from "pages/LicenseTemplate/licenseTemplateRoute";
import otaHmacRoute from "pages/Packages/PackagesTabs/OtaHmacPage/otaHmacRoute";
import versionsRoute from "pages/Versions/versionsRoute";
import versionRoute from "pages/Version/versionPageRoute";
import packagesRoute from "pages/Packages/packagesRoute";
import packageAssignRoute from "pages/PackageAssignPage/packageAssignRoute";
import apnsPushCenterAssignRoute from "pages/PushCenterAssignPage/APNS/apnsPushCenterAssignRoute";
import fcmPushCenterAssignRoute from "pages/PushCenterAssignPage/FCM/fcmPushCenterAssignRoute";
import pushCentersRoute from "pages/PushCenters/pushCentersRoute";
import systemRoute from "pages/System/systemRoute";
import roleRoute from "pages/RolePage/roleRoute";

export default [
  dashboardRoute,
  accountsRoute,
  accountRoute,
  licensesRoute,
  licenseTemplateRoute,
  versionsRoute,
  versionRoute,
  packagesRoute,
  packageAssignRoute,
  apnsPushCenterAssignRoute,
  fcmPushCenterAssignRoute,
  otaHmacRoute,
  pushCentersRoute,
  iuVersionsRoute,
  iuVersionRoute,
  systemRoute,
  roleRoute,
  actionLogRoute,
];
